module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "CHAPTER 1"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2ch",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('span', {
    staticClass: "bg"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch1"
    }
  }, [_vm._v("CHAPTER 1")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("November 1946")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Queen Alexandra’s Military Hospital, London")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1t"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('b', [_vm._v("E")])]), _c('b', [_vm._v("RNST KOEHLER’S INDEX")]), _vm._v(" finger and thumb on his left hand ached like they’d been hit with a hammer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Which surprised him, because he no longer had an index finger and thumb on that hand to ache.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He squeezed what remained of his fist tight and looked at his watch. He reached into the pocket of his trench coat for his cigarettes, then opened the top of the pack with his teeth before shaking one free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is no smoking here, Major,” the English hospital orderly said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The little man was already looking down at the floor, away from the death’s-head badge on Koehler’s SS cap, before he finished the sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Shut up,” said Koehler, cigarette already in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler produced a box of matches and passed them to the Gestapo officer to his right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Schmitt looked at them for a moment, and then back up at his boss.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Light me,” Koehler said, cigarette bobbing, left hand held up as proof of its ineffectiveness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt fumbled with the box, nerves on edge, before finally managing to light a match and put it to the cigarette. Koehler grunted, drew deeply, and closed his eyes, agitation eased for a few minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held out his hand for the matches, and Schmitt passed them back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” Koehler said in German.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt didn’t reply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you okay?” Koehler tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt looked at the orderly, then back to Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He doesn’t speak German—none of them do, it’s the rules.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still don’t want to talk in front of him,” Schmitt whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have a problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt shook his head unconvincingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you have a problem, you need to tell me,” Koehler tried again, then took another drag on the cigarette.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt looked at the back of the orderly’s head once more, then at Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is wrong, what we are doing. It’s wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Visiting Rossett is wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes. Well, no, but yes. After the damage he caused—” Schmitt broke off and looked at the orderly again, then shook his head. “We shouldn’t be here. Now isn’t the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler stared at the Gestapo man for a moment, then leaned in close.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("“How long have you worked for me?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Technically I don’t work "), _c('i', [_vm._v("for")]), _vm._v(" you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Koehler’s turn to frown.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am I your boss?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Technically, yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, technically, how long have you worked for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt looked at Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A month or so, although I’m Gestapo liaison, so technically—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler cut him off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s been eventful, hasn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What has?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This month, it’s been eventful?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you call chasing Rossett and some Jewish kid all over London for the last week eventful? Well, then, yes, it has; but personally, I’d say it’s been more madness than anything else. Madness that has nearly cost me my job, and my life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you are alive, Schmitt, and if you want to stay alive, you’ll stick with me while I sort this out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re German officers.” Schmitt looked at the orderly again, subconsciously lowering his voice as he continued, even though he was still speaking in German. “We shouldn’t have to sort things out. Things should be done correctly in the first place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You just follow my lead. If you want to stay alive, follow my lead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt shook his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When this is over I want out of your department.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want out of your department . . . "), _c('i', [_vm._v("sir,")]), _vm._v("” Koehler replied, then regretted it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("“I want out of your department, "), _c('i', [_vm._v("sir")]), _vm._v(". I can’t operate like this, this way that you work, breaking rules, running wild. I can’t do it. I want out. If you give me your word I can go, I’ll do as you say.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler put the cigarette back in his mouth as he looked into Schmitt’s eyes. He pondered the offer, taking the time to take a deep drag and weigh up his options; finally, he exhaled and spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You follow my lead this morning with Rossett, and then I’ll recommend your transfer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler nodded, then nudged the orderly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much longer?” Smoke drifted from his nose and mouth as he spoke, this time in English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t know, sir, maybe ten minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ten minutes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe less, it all depends . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The orderly didn’t finish his sentence. Koehler had already pushed through the double doors and was limping up the middle of the half-empty ward. Schmitt sighed heavily and followed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were eighteen beds, occupied by men in various states of distress, but Koehler didn’t pay attention to them. He headed straight for the one at the top of the ward on the left-hand side. The bed that had curtains drawn around it and two bored SS guards sitting at its foot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The two guards stood up when they realized there was a uniformed SS major limping his way toward them. One of the guards dropped a newspaper on the floor, made to pick it up, then thought better. He eventually made an awkward attempt at standing to attention, half up, half down, MP40 swinging in its sling in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler ignored the guards, pulled back the curtain around the bed a few inches, and stepped inside. A doctor was bent over "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("the patient and another orderly stood behind him, holding a tray of bloodied bandages and cotton wool. Both men turned to Koehler, who looked first at the tray and then at the doctor.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out,” Koehler said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m treating this man.” The doctor turned to face Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The orderly was less belligerent. He stepped backward through the gap in the curtains without a word, like a bad comedian glad to get off the stage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The English doctor held a thick cotton wool wad in front of him, bloody proof of his need to be there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You need to wait until I’m finished.” This time the doctor’s voice was stronger, given weight by years of telling people what to do and them doing it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get out,” repeated Koehler flatly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll do no such thing. I’m—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Schmitt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Schmitt appeared through the curtains and stared at the doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Herr Major?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take the doctor outside,” Koehler said in English for the doctor’s benefit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m treating this man; you can’t just walk in here. I refuse to leave. This man is my patient. He—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And shoot him?” Schmitt said in English, staring at the doctor, who fell silent, lowering the bandage slowly to his side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not yet,” replied Koehler flatly, eyes still on the doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The doctor looked at Schmitt, then at Koehler, and quietly stepped out through the curtains. Schmitt nodded to Koehler and followed the doctor out of the gap before closing it quietly behind him. Koehler listened to their footsteps fade away farther down the ward, Schmitt following his earlier orders to move everyone out "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("of earshot. Koehler waited, then turned and looked down at John Henry Rossett, who stared back at him through heavy-lidded eyes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, John,” Koehler said in English, well aware that Rossett’s German was terrible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ernst,” Rossett replied through cracked lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler took another drag of his cigarette. He noticed Rossett’s eyes following the smoke as he took it out of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He held up the cigarette to Rossett.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Can you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett nodded, so Koehler held the cigarette to his lips and watched as he took a drag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett closed his eyes before letting the smoke rise back out of his lungs and float to the ceiling. He finally looked up at Koehler, managed a half smile of thanks, then closed his eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler put the cigarette into his own mouth before lifting the loose cotton wadding from Rossett’s stomach to reveal an inch-wide open wound. The wound had a faint whiff of infection, and Koehler softly tutted before gently placing the dressing back down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s the hand?” Rossett whispered, eyes still closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fucked. Index finger and thumb gone.” Koehler held up his gloved left hand, but Rossett still had his eyes closed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler shrugged, looked at it himself and then dropped it to his side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry about that,” Rossett whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How’s the stomach?” Koehler put the cigarette back to Rossett’s lips.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett took the barest of breaths, struggling to breathe life into the ember at the tip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_vm._v("“It went straight through, came out clean the other side,” he finally said after giving up on the cigarette.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” Koehler smiled, then sat down on the edge of the bed. His weight caused the mattress to sag, and Rossett groaned as gravity made him shift slightly. Koehler half rose, then settled again, this time more gently.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I need to sit. I’m sorry, this leg is killing me,” Koehler said. “I took a round through the calf in the firefight at the pub, when you were trying to get away with the boy and Kate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett opened his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me and you got pretty banged up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lucky to be alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Are you sure about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler chuckled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sat in silence for a while until Koehler spoke again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t believe you threw it all away. You had a good job, good living, quiet life, and you go and throw it all away for one Jewish kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Throw it all away?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We had it good, and you risked screwing it up like that.” Koehler looked around for somewhere to get rid of the cigarette. “You threw it all down the drain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was already down the drain.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You had everything.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything?” Rossett opened his eyes again. “I worked for you rounding up Jews, just so you could cart them off to . . . well, God knows where.” Rossett paused as he drew another shallow breath and looked at the ceiling above his bed. “I have no family, no home, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_vm._v("no future, and no friends.” Another pause, another shallow breath. “I didn’t throw anything away, Ernst, because I didn’t have anything to throw away. That child, Jacob, he . . . I don’t know.” Rossett looked for the words. “He made me feel human.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler gave up looking for somewhere to put the cigarette and settled for dropping it on the floor. He leaned forward slightly so that he could rest his elbows on his knees, staring at the butt that was still smoking next to his boot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His head hung low on his weary shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was your friend,” Koehler finally said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were trying to kill me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was doing my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett chuckled, then grimaced as his stomach tightened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler looked up from the cigarette butt, waiting for Rossett’s pain to pass before speaking again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re part of a machine, John. I don’t like it any more than you do, but the fact is, we are part of a machine. We’re told to round up the Jews in London, so that’s what we do. What happens to them, where they go, it isn’t our concern. You taking that child, helping him, stopped you doing what you were supposed to do, and that nearly caused the machine to break down.” Koehler rubbed his hand again. “If I didn’t try to fix what was broken, it would have been fixed by someone else. I had no choice but to do what I did. You have to remember: whatever I think about the machine, how I feel about what it does, it doesn’t matter. If I don’t do what I’m supposed to do . . . I die.” Koehler rummaged in his coat pocket for his cigarettes again, then thought better of it. He looked back at the cigarette butt on the floor before continuing, his voice lower this time, softer. “I still have my family, John. They mean everything "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("to me. I couldn’t risk their future, not for you, not for the Jewish kid you were trying to help, and not for the Jews we round up. I’m sorry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m here to fix things—between us, and between you and my bosses. We need to get you back in the machine before it is too late,” Koehler said, half turning his head to look at Rossett again, checking his reaction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if I don’t want to go back into the machine?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t want to start thinking like that, trust me. You need to get back on board and quickly, while we can still keep some sort of lid on this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How?” Rossett opened his eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s complicated.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Am I going to prison?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler shrugged, removed his cap, and ran his right hand through his thick blond hair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I still don’t understand. Why did you do it?” Koehler looked at his cap. He gently straightened the death’s-head badge as he waited for Rossett’s answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett swallowed, staring up at the ceiling, looking for the words before he finally replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Saving the boy, getting him away from it . . . from this . . . this place.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“London?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“England, Britain, what it’s become.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“One kid? You’ve helped send thousands to . . . wherever they go to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at Koehler. “I wanted it, helping him . . . I wanted "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_vm._v("it to save me. I woke up, looked around at what I’d done, what I was doing. I wanted him to save me from what I . . . what we were doing.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you don’t mind me saying so, John”—Koehler nodded his head to the injury on Rossett’s stomach—“you don’t look much saved.” Koehler spun his cap in his fingers slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The edges of Rossett’s mouth twitched and he went back to staring at the ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I feel saved. I feel better inside than I’ve felt in years. Doing something good, instead of doing what we usually do. Whatever happens to me from now, I know I did the right thing for Jacob.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But not for yourself?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t get it, do you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Apparently not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I had someone other than myself to think about, for the first time since my wife and son died. When they were blown up by the resistance, something in me . . . stopped working. Some part of me changed. I thought I was broken forever.” Rossett paused, and then went back to looking at the cracked hospital ceiling. “I don’t know, Ernst. That kid brought me back to life; he made me see what I’d become. I had someone to care about, to look after, and to do the right thing for. All this . . .” Rossett pointed at his stomach. “It was worth it. It was all worth it to find myself again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They sat quietly as someone at the other end of the ward called for a nurse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody answered. Schmitt was doing his job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, what happens to me now? Do I go to prison?” Rossett said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Executed?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What’s the point? You’re already half dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("“So what, then?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re the British Lion, John, the Führer’s favorite Englishman, remember? You’re a hero, and the Reich needs heroes.” Koehler spun his cap again, then looked at Rossett. “So the Reich needs you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett raised an eyebrow. “The Reich needs me or you need me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler waved his hand and continued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The statement the British High Command will release is going to say that you were shot by the resistance as you tried to stop gun smugglers at Wapping docks. You were working for the Reich, assisting in the glorious battle against the cowardly communist and royalist resistance, who are determined on undermining the glorious future of Great Britain and the British Fascist Party. You bravely tackled a group of men who were about to launch a terror campaign against the civilian population. You nearly died protecting a platoon of German soldiers.” Koehler turned to Rossett. “The diary we found on you, the one you had in your pocket? It was pretty water damaged, but there were a lot of useful names and addresses we can use. That alone has given the Gestapo enough reason to celebrate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No mention of Jacob?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody will miss one Jewish kid.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Kate?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If anyone asks, she’s been transferred up north.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But nobody will ask?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Probably not. It’s best not to when people disappear, you know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But "), _c('i', [_vm._v("I")]), _vm._v(" don’t disappear. Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re a hero, and you will be rewarded for your heroism.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rewarded.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("“You’re getting a medal.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if I don’t want it? What if I don’t agree to this?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler shook his head and puffed out his cheeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That is where things get tricky. If you don’t comply with this arrangement, all of this arrangement, I’ve been authorized to explain to you that you’ll tragically die of your wounds, probably here, probably today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No doubt I’ll succumb to infection as well, or, if I’m really unlucky, I’ll end up out east fighting the Chinese and the Russians.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both men sat in silence, surrounded by curtains, amid the smell of hospital food and disinfectant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The patient down the ward called out again, this time louder, but with no more success than before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Die of my wounds?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe that would be easier?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t be stupid, John. Just nod your head and we come through in one piece. Shake it and things will be exactly the same, except you’ll be dead and my wife will be a widow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why are they doing this for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler clenched his fist again and leaned forward, looking down at his boots once more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This hand hurts like hell.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett looked at the hand, then at his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Swap?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They stared at each other for a moment before Koehler’s eyes seemed to dim, the bright blue turning a sad shade of gray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If you die, the English High Command have to explain why "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("they let the British Lion, the Führer’s favorite Englishman, charge around getting shot, just before the Führer sends someone to London to give him a medal. The Führer needs you, and he wants you standing up, not lying in a box. Keeping the Führer happy, that’s the number-one rule of being a high-ranking German officer. And the high-ranking German officers I answer to know this; that is why you will come through the other side of this.” Koehler straightened up again and looked squarely at Rossett. “The last few days have been—well, let’s just say they haven’t gone well for me. The shootings all over London, the dead soldiers—none of it looks good for my bosses and me, unless we can put a positive spin on the events. If we can paint you as a hero, things will improve, and my bosses can stand behind you. You get to take the glory, and we get to fight another day. If you die, I die, either in a cell in London or a trench in Russia. I’ll be honest, I don’t fancy either much.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I die, what do I care?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not a lot, but . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They’ll follow up on Kate. She was my secretary, and she was seen with you before she fell off the face of the earth. We know she was helping you; we aren’t idiots. You might have got her out of the country with the kid, but they’ll track her down easily enough if they want to.” Koehler shook his head. “They can make things go badly for her over there.” Koehler leaned in close. “They know what strings to pull, John. They’ll let it be known to the Americans that she worked for the SS, for me, rounding up the Jews. They can also let it be known that she still is working for us. That’ll soon make its way to Canada. They can make her look very bad, very, very bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even though it isn’t true?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Some of it is, some of it isn’t. All you need to know is that the "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("British government abroad hangs traitors. You don’t want that for Kate, do you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She wasn’t a traitor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe not at the end, but whether you like it or not, she was a traitor, same as you are. You were both working for the Germans, and you were both involved in rounding up Jews. That’ll get you on the end of a rope. Your agreement to the official explanation I’m offering you now will make certain she is left alone.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I lie?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doesn’t everyone?” Koehler tilted his head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Traitors to the truth,” Rossett replied, closing his eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You got very close to her, John, in the madness of what was happening with the kid. I know you did. She was a special person. I was . . . well . . . I was very fond of her myself. If you have feelings for her, you’ll agree to what I’m offering.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither man spoke for over a minute until Koehler tried again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do we have a deal?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about Schmitt, and the men who died?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If I go down, Schmitt goes down. He knows that; he isn’t an idiot. Shit rolls downhill, and if it doesn’t I’ll give it a push. He knows why I’m here, he knows what I’m saying, and he knows if we can make this stick we all stay alive, and maybe, just maybe, we’ll look good in the morning. If he keeps his mouth shut I’ll let him move on out of my office, which will buy his silence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And the men?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is war. Men die.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A dirty secret,” Rossett whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Our secret,” Koehler replied, looking longingly at the now long-dead cigarette butt. “You get your medal; I get to give my bosses the resistance men you killed and the timber yard full of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("guns we uncovered. You just need to agree with the account of what took place.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The man who shot me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s an old soldier, don’t worry. Just nod your head, come on . . . please, John, for me, for my family?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett opened his eyes again and looked sadly at Koehler.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can’t decide what would be better, to live or die. Isn’t that terrible?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Live to fight another day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m tired of fighting, Ernst; I can’t go back to that job, what we do . . . I can’t, not anymore. I’ve changed. I’m not that person, the man who loads the trains. I can barely live with the thought of what we did, what we do. I won’t do it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can get you a nice quiet job, little office with some paper to shuffle, out of the way? I could maybe get you back in the police, just like old times? You just have to nod your head, take your medal, sign a statement. That’s all. Then you get a quiet life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to be a policeman again. I want to go back to my old job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll not put another soul in a boxcar. I want to do some good again, be a better man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, you can be a policeman.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett shut his eyes and rested his head back on the pillow. For a moment Koehler thought he’d fallen asleep, and he leaned forward slightly to check.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally Rossett spoke. “All right, I’ll sign.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It makes sense. We’ll be heroes, John, smelling of roses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’ll never be heroes again, Ernst, not after the things we’ve done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler didn’t reply. He stood up off the bed and smoothed his "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("tunic before looking down again at the man he hoped was still his friend. After a second or two he nodded silently and turned to leave through the gap in the curtains.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ernst?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler stopped and looked back at Rossett, who had opened his eyes again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The boy, have you heard?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Koehler rubbed his hand again before struggling to button his coat against the cold November afternoon that waited outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They are on a plane to America. My contact in Dublin says the boy is well and has an American passport.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rossett closed his eyes and rested his head back on the pillow.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-352f84d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062394613_Chapter_1.vue
// module id = 72
// module chunks = 0